import { render, staticRenderFns } from "./ShortDescription.vue?vue&type=template&id=d314171a&"
import script from "./ShortDescription.vue?vue&type=script&lang=js&"
export * from "./ShortDescription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports